import * as React from "react";
import * as classes from "./Divider.css";

interface DividerProps {}

// Divider renders a divding line.
export default function Divider(props: DividerProps) {
  return <hr className={classes.hr} />;
}
